import jwt_decode from 'jwt-decode';
import { clearTokens, getAccessToken } from 'src/helpers/auth';
import type { RouteLocationNormalized, NavigationGuardNext } from 'vue-router';

export default async (
  perms: string[], 
  to: RouteLocationNormalized, 
  from: RouteLocationNormalized, 
  next: NavigationGuardNext
) => {
  if (!getAccessToken()) {
    next('/login');
    return;
  }

  try {
    const data = jwt_decode(getAccessToken());
    if (data.perms) {
      if (data.perms.some((r) => perms.indexOf(r) >= 0)) {
        next();
      } else {
        next('/noaccess');
        //next();
      }
    } else {
      clearTokens();
      next('/login');
    }
  } catch (err) {
    console.log(err);
    clearTokens();
    next('/login');
  }
};
